import ListOfTitleProtocolAndThesis from "src/pages/DissertationAndThesis/ListOfTitleProtocolAndThesis/ListOfTitleProtocolAndThesis";

export const listOfTitleProtocolAndThesisRoutes = [
  { path: '/thesis-dissertation-title-and-protocol-management', component: ListOfTitleProtocolAndThesis },
];
